export const normalizeAge = (value) => value.replace(/^0+(?=\d)/, "");

export const ageError = (age) => {
  const value = Number(age);
  return !Number.isInteger(value) || value < 1 || value > 120 ? "Enter an age from 1 to 120." : "";
};

export const medicationError = (med) => {
  if (!!med.name?.trim() === !!med.brand_name?.trim()) {
    return "Enter either the generic name or the brand name, not both.";
  }
  const dose = (med.dose || "").trim();
  const match = dose.match(/^(\d+(?:\.\d+)?|\.\d+)\s*([a-zA-Zµμ].*)$/);
  if (!match || Number(match[1]) <= 0) return "Enter a dosage amount and unit, e.g. 500 mg or 1 tablet.";
  return "";
};

export const medicationsError = (meds) => {
  for (let i = 0; i < meds.length; i++) {
    const message = medicationError(meds[i]);
    if (message) return `Medication ${i + 1}: ${message}`;
  }
  return "";
};

export const profileErrorMessage = (error) => {
  const detail = error.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg).join(". ");
  return typeof detail === "string" ? detail : "Could not save profile. Please try again.";
};

export const cleanMedications = (meds) => meds.map((med) => ({
  ...med,
  name: (med.name || "").trim(),
  brand_name: (med.brand_name || "").trim() || null,
  dose: (med.dose || "").trim(),
  frequency: (med.frequency || "").trim() || null,
}));